import { useEffect, useState } from 'react';

const offTm: ReturnType<typeof setTimeout> | null = null;

const ScreenLoader = () => {
	const [isOff, setIsOff] = useState(false);

	useEffect(() => {
		if (offTm) {
			clearTimeout(offTm);
		}
		setTimeout(() => {
			setIsOff(true);
		}, 1000);

		return () => {
			if (offTm) {
				clearTimeout(offTm);
			}
		};
	}, []);

	return (
		<div
			className={`screen-loader${isOff ? ' screen-loader--off' : ''}`}
			style={{
				background: '#e00314',
			}}
		>
			<span
				className="loader"
				style={{
					borderBottomColor: '#ffc13cff',
				}}
			></span>
		</div>
	);
};

export default ScreenLoader;
